module.exports = __webpack_public_path__ + "img/payments-needs-review-empty.b85e34d0.png";